import { BaseService } from '@zaoblako/web/core/services/base.service';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CashFlowItemService extends BaseService {
  protected baseUrl = '/basis/catalog/cash-flow-item';

  public get dropdownDescriptorApi(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }
}
